export default {"src":"/_next/static/media/box.a19cc517.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};